export const GROUP_FORM_MODAL_ADD_NEW = 'GROUP_FORM_MODAL_ADD_NEW'
export const GROUP_FORM_MODAL_EDIT = 'GROUP_FORM_MODAL_EDIT'
export const GROUP_FORM_MODAL_CLOSE = 'GROUP_FORM_MODAL_CLOSE'
// #3422 QuickFix - Allow to create parent classes in the parent respondent view.
// This will be removed soon.
export const GROUP_FORM_MODAL_SWITCH_TO_PARENT_CLASS = 'GROUP_FORM_MODAL_SWITCH_TO_PARENT_CLASS'


export const CLASSES_SET = 'CLASSES_SET'
export const CLASSES_ADD = 'CLASSES_ADD'
export const CLASSES_DELETE = 'CLASSES_DELETE'
export const CLASSES_UPDATE = 'CLASSES_UPDATE'
export const CLASSES_LOADING = 'CLASSES_LOADING'
export const CLASSES_ERROR_SET = 'CLASSES_ERROR_SET'

export const TEACHERS_SET = 'TEACHERS_SET'

export const SUBJECTS_SET = 'SUBJECTS_SET'
export const SUBJECTS_ADD = 'SUBJECTS_ADD'

export const USER_SET = 'USER_SET'
export const USER_NAME_SET  = 'USER_NAME_SET'
export const USER_SURNAME_SET  = 'USER_SURNAME_SET'
export const USER_TYPE_SET  = 'USER_TYPE_SET'

export const ORG_NAME_SET = 'ORG_NAME_SET'

export const MODULES_SET = 'MODULES_SET'

export const SURVEY_REFRESH_SET = 'SURVEY_REFRESH_SET'
export const POLL_REFRESH_SET = 'POLL_REFRESH_SET'


export const SSO_ENABLED_SET = 'SSO_ENABLED_SET'
export const PERMISSION_SET = 'PERMISSION_SET'

export const AP_EDITING_ACTIVE_SET = 'AP_EDITING_ACTIVE_SET';

export const ONBOARDING_SET = 'ONBOARDING_SET';
export const ONBOARDING_UPDATE = 'ONBOARDING_UPDATE';

// Superadmin
export const SET_OPEN_INFO_LABEL_DATE = 'SET_OPEN_INFO_LABEL_DATE';

// Freemium
export const SET_ACTIVE_METRICS_FREEMIUM_INFO = 'SET_ACTIVE_METRICS_FREEMIUM_INFO'
export const SET_BENCHMARK_FREEMIUM_ENABLED = 'SET_BENCHMARK_FREEMIUM_ENABLED'

// Filters
export const FILTERS_SET = 'FILTERS_SET'
export const FILTERS_COUNT_LEGACY_SET = 'FILTERS_COUNT_LEGACY_SET'
export const FILTERS_COUNT_EXISTING_SET = 'FILTERS_COUNT_EXISTING_SET'
export const FILTERS_COUNT_EXPECTED_SET = 'FILTERS_COUNT_EXPECTED_SET'
export const FILTERS_ACTIVE_SET = 'FILTERS_ACTIVE_SET'
export const FILTERS_POPUP_SET = 'FILTERS_POPUP_SET'
export const FILTERS_CAN_EDIT_SET = 'FILTERS_CAN_EDIT_SET'
